import { OmvqVeterinarian } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useSearchOmvqVeterinariansQuery<D extends OmvqVeterinarian>(
  params?: HydraQueryParams<D>
) {
  const { vars, options, key } = params || {};

  return useHydraQuery<D>(key ?? `searchOmvqVeterinariansQuery`, `/api/omvq_veterinarians/search`, {
    vars,
    options,
  });
}
